module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/386/assets/fonts/4800a45cb26b5257be4a1d6b6a0eb5f9.eot";


//////////////////
// WEBPACK FOOTER
// ./app/styles/fonts/icomoon.eot?qmfery
// module id = 449
// module chunks = 3